"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.array.index-of.js");

var _normalizeWheel = _interopRequireDefault(require("normalize-wheel"));

var isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

var mousewheel = function mousewheel(element, callback) {
  if (element && element.addEventListener) {
    element.addEventListener(isFirefox ? 'DOMMouseScroll' : 'mousewheel', function (event) {
      var normalized = (0, _normalizeWheel["default"])(event);
      callback && callback.apply(this, [event, normalized]);
    });
  }
};

var _default = {
  bind: function bind(el, binding) {
    mousewheel(el, binding.value);
  }
};
exports["default"] = _default;